module.exports = __webpack_public_path__ + "static/img/zh_CN1.48d3e54.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zh_CN1.png
// module id = DXVa
// module chunks = 1